export const defaultData = {
  username: '',
  password: '',
  trading_mode: 'paper',
  is_connected: false,
  is_checked: false
}

export const defaultStatus = {
  loaded: false,
  exists: false,
  liveModal: false,
  disabling: false
}
